"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var arrowRight = exports.arrowRight = { "viewBox": "0 0 1536 1792", "children": [{ "name": "path", "attribs": { "d": "M1472 960q0 54-37 91l-651 651q-39 37-91 37-51 0-90-37l-75-75q-38-38-38-91t38-91l293-293h-704q-52 0-84.5-37.5t-32.5-90.5v-128q0-53 32.5-90.5t84.5-37.5h704l-293-294q-38-36-38-90t38-90l75-75q38-38 90-38 53 0 91 38l651 651q37 35 37 90z" } }] };


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-icons-kit/fa/arrowRight.js
// module id = 825
// module chunks = 1